<template>
  <el-dialog title="补录学时申请" :visible.sync="dialogVisible" center @close="afterClose()" width="600px" append-to-body
    :close-on-click-modal="false">
    <el-form ref="form" :model="form" label-width="150px" label-suffix=" :" size="mini" :rules="rules">
        <el-form-item label="培训名称" prop="name">
          <el-input v-model="form.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="主办单位" prop="orgName">
          <el-input v-model="form.orgName" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="培训时间" prop="time">
          <el-date-picker
          v-model="form.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          value-format="yyyy-MM-dd"
          end-placeholder="结束日期"
          class="daterangepicker"
          >
        </el-date-picker>
        </el-form-item>
        <el-form-item label="学时" prop="hours">
          <el-input v-model="form.hours" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="证明材料" prop="fileName" >
          <div class="zmcl ">
            <el-input v-model="form.fileName" clearable placeholder="请选择" disabled ></el-input>
                <Upload @success="UploadChange($event)" buttonText="选择文件"/>
          </div>
          
              </el-form-item>
        
        <el-form-item>
          <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
          <el-button type="danger" @click="save" size="mini">提 交</el-button>
        </el-form-item>
      
    </el-form>
  </el-dialog>
</template>
<script>
import { list, apply } from "@/api/statistics.js";
export default {
  name: "resetPassword",
  components: {},
  data () {
    return {
      dialogVisible: false,
      form: {
        name:'',	//培训班
                        orgName:'',//主办单位
                        startTime:'', //培训开始时间
                        endTime:'', //培训结束时间
                        hours:	'',//学时
                        fileUrl:'', //证明材料地址
                        fileName: '',//证明材料名称
                        time:'',
                        // status:'',//状态，待审核、已通过、不通过
                        // applyTime:'',//申请时间
      },
      info: {},
      rules: {
        name: [
          { required: true, message: '请输入培训班', trigger: 'blur' }
        ],
        orgName: [
          { required: true, message: '请输入主办单位', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请选择培训开始时间', trigger: 'blur' }
        ],
        hours: [
          { required: true, message: '请输入学时', trigger: 'blur' },
          {pattern:/^[0-9]+(.[0-9]{1,2})?$/,message: '学时必须是数字，且能够保留2位小数', trigger: ['blur','change']}
        ],
        fileName: [
          { required: true, message: '请选择证明材料', trigger: 'blur' }
        ],
      },
      smsSecond: 0,
    };
  },
  beforeDestroy () {
   
  },
  methods: {
    reset () {
      this.$refs.form.resetFields()
    },
    open (params) {
      this.dialogVisible = true
    },
    close () {
      this.dialogVisible = false
    },
    afterClose () {
      this.reset();
    },
    
    save () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params={
            ...this.form,
            startTime:this.form.time[0], 
            endTime:this.form.time[1], 
          }
          apply(params).then((res) => {
            this.$message({
                  message: res.message || res.msg || "操作成功",
                  type: 'success'
                })
                this.close()
                this.$emit('saveOk')
            })
        } else {
          return false;
        }
      });
    },
    UploadChange(params) {
            this.form.fileUrl=params.url
            this.form.fileName=params.name
        }
  },
};
</script>
<style lang="scss" scoped>
.code {
  ::v-deep .el-form-item__content {
    display: flex;
  }
}
.daterangepicker{
  width:100%;
}
.zmcl{
  display: flex;
}
</style>